export default __webpack_public_path__ + "static/media/drivers-license-back.27eda178.svg";